import type { FC } from "react";

import type {
  TResponsiveNavigationItemProps,
} from "@/ui/components/navigation/ResponsiveNavigation/ResponsiveNavigation.config";
import { Icon } from "@/ui/components/primitives/Icon";
import { TextControl } from "@/ui/components/typography/TextControl";
import { cn } from "@/ui/lib/utils";

export const ResponsiveNavigationItem: FC<
  TResponsiveNavigationItemProps
> = ({ isActive, item }) => {
  const { href, icon, label, linkProps } = item;

  return (
    <li className="min-w-0 flex-1 xl:flex-none">
      <a
        {...linkProps}
        href={href}
        aria-current={isActive ? "page" : undefined}
        data-component="ResponsiveNavigationItem"
        className={cn(
          "group",
          "flex min-w-0 flex-col items-center justify-center gap-1 rounded-sys-full px-1 py-2 text-foreground no-underline outline-none transition-colors",
          "hover:bg-component-responsive-navigation-item-active focus-visible:ring-2 focus-visible:ring-primary",
          "xl:flex-row xl:justify-start xl:gap-2 xl:px-4 xl:py-2",
          "hover:bg-component-interactive-hover focus:bg-component-interactive-hover",
          isActive && "bg-component-interactive-hover",
          linkProps?.className,
        )}
      >
        <Icon
          icon={icon}
          size="sm"
          aria-hidden="true"
          className={cn(
            "shrink-0",
            "group-hover:[&_svg]:fill-sys-chartreuse-600 group-hover:[&_svg]:stroke-foreground",
            isActive && "[&_svg]:fill-sys-chartreuse-600 [&_svg]:stroke-foreground",
          )}
        />
        <TextControl
          size={3}
          className="max-w-full truncate text-center xl:text-left"
        >
          { label }
        </TextControl>
      </a>
    </li>
  );
};

ResponsiveNavigationItem.displayName = "ResponsiveNavigationItem";
